import React, { useState } from "react";
import { Link } from "react-router-dom";

const outlets = [
  { name: "Head Office", address: "Showgrounds, Lusaka" },
  { name: "Garden City Mall", address: "Great East Rd, Lusaka" },
  { name: "Kamploops Mall", address: "Kalingalinga" },
  { name: "Libala Mall", address: "Libala" },
  { name: "Builders Depot", address: "New Kasama / Bauleni" },
  { name: "ZAF Twin Palm", address: "Ibex" },
  { name: "ZAF Lusaka", address: "Airport Rd" },
  { name: "ZAF Lusaka West", address: "Mungwi Rd" },
  { name: "Makeni (Coming Soon)", address: "Makeni" },
];

const phoneNumbers = [
  "+260 97 4738957",
  "+260 95 5215724",
  "+260 77 6524201",
  "+260 77 6524210",
  "+260 96 9488464",
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for your message. We will get back to you shortly.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="contact">
      {/* Hero */}
      <section
        className="page-hero"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      >
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </section>

      <section className="section container">
        <div className="contact-grid">
          {/* Left column – Contact info */}
          <div>
            <h2 className="section-title">Get in Touch</h2>

            <div className="contact-info-block">
              <h3>Outlets</h3>
              <ul>
                {outlets.map((o, i) => (
                  <li key={i}>
                    <strong>{o.name}:</strong> {o.address}
                  </li>
                ))}
              </ul>
            </div>

            <div className="contact-info-block">
              <h3>Phone Numbers</h3>
              <ul>
                {phoneNumbers.map((num, i) => (
                  <li key={i}>{num}</li>
                ))}
              </ul>
            </div>

            <div className="contact-info-block">
              <h3>Email</h3>
              <p>info@tranquilitydis.com</p>
            </div>

            <div className="contact-info-block">
              <h3>Follow Us</h3>
              <a
                href="https://www.facebook.com/AfroxgasrefillLusaka"
                target="_blank"
                rel="noreferrer"
                className="social-link"
              >
                Facebook
              </a>
            </div>

            <div className="contact-info-block">
              <h3>Operating Hours</h3>
              <p>Monday – Saturday: 08:30 – 19:00</p>
              <p>Public Holidays: 09:00 – 13:00</p>
            </div>
          </div>

          {/* Right column – Form */}
          <div>
            {/* <h2 className="section-title">Send a Message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="btn-primary btn">
                Send Message
              </button>
            </form> */}

            <div style={{ marginTop: "5%" }}>
              <a
                href="https://wa.me/260977815724"
                className="btn-outline btn"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
